"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultKpiDeleteDialog = exports.useKpiDeleteDialogProps = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var react_intl_1 = require("react-intl");
var model_1 = require("../../model");
/**
 * @internal
 */
function useKpiDeleteDialogProps() {
    var dispatch = model_1.useDashboardDispatch();
    var coordinates = model_1.useDashboardSelector(model_1.selectKpiDeleteDialogWidgetCoordinates);
    var onCancel = react_1.useCallback(function () { return dispatch(model_1.uiActions.closeKpiDeleteDialog()); }, [dispatch]);
    var onDelete = react_1.useCallback(function () {
        return model_1.dispatchAndWaitFor(dispatch, model_1.eagerRemoveSectionItem(coordinates.sectionIndex, coordinates.itemIndex)).finally(function () {
            dispatch(model_1.uiActions.closeKpiDeleteDialog());
        });
    }, [coordinates, dispatch]);
    var isVisible = model_1.useDashboardSelector(model_1.selectIsKpiDeleteDialogOpen);
    return {
        isVisible: isVisible,
        onCancel: onCancel,
        onDelete: onDelete,
    };
}
exports.useKpiDeleteDialogProps = useKpiDeleteDialogProps;
/**
 * @internal
 */
exports.DefaultKpiDeleteDialog = function (props) {
    var isVisible = props.isVisible, onDelete = props.onDelete, onCancel = props.onCancel;
    var intl = react_intl_1.useIntl();
    if (!isVisible) {
        return null;
    }
    return (react_1.default.createElement(sdk_ui_kit_1.ConfirmDialog, { onCancel: onCancel, onSubmit: onDelete, isPositive: false, className: "s-dialog", headline: intl.formatMessage({ id: "deleteKpiConfirmationDialog.headline" }), cancelButtonText: intl.formatMessage({ id: "cancel" }), submitButtonText: intl.formatMessage({ id: "deleteKpiConfirmationDialog.submitButtonText" }) },
        react_1.default.createElement(sdk_ui_kit_1.Typography, { tagName: "p" },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "deleteKpiConfirmationDialog.message" }))));
};
//# sourceMappingURL=DefaultKpiDeleteDialog.js.map